
import { AccountEffects } from './account.effects';
import { AdminEffects } from './admin.effects';
import { AuthEffects } from './auth.effects';
import { CampusEffects } from './campus.effects';
import { PaymentEffects } from './payment.effects';
import { ProfessorEffects } from './professor.effect';
import { ScheduleEffects } from './schedule.effects';
import { SchoolEffects } from './school.effects';
import { SharedEffects } from './shared.effects';
import { StudentEffects } from './student.effects';
import { AddressEffects } from './address.effects';
export const effects: any[] = [
    AccountEffects,
    AuthEffects,
    CampusEffects,
    PaymentEffects,
    SchoolEffects,
    StudentEffects,
    SharedEffects,
    ScheduleEffects,
    ProfessorEffects,
    AdminEffects,
    AddressEffects
];
